import Config from "../config";

/**
 * Formatta gli importi
 * @param value valore decimale da formattare
 * @param currency codice ISO 3 cifre della valuta associata, se non definito viene presa di default della configurazione del sito
 */
export default ({value, currency = null, ...props}) => {
    if (currency === null) {
        currency = Config.betting['currency'] || 'EUR';
    }
    if (currency === "$") {
        currency = 'USD';
    }

    //> Formatta la valuta in modo appropriato in base
    //> sia alla currency scelta sia in base alla lingua letta dal browser
    try {
        const formatter = new Intl.NumberFormat({}, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const formattedValue = props['allow-break'] ? formatter.format(value).replace(/[\s\u00A0]/, ' ') : formatter.format(value);
        
        return <span class="money-format">
            {formattedValue}
        </span>;
    } catch (e) {
        console.warn(e, value, currency);

        return <span class="money-format">
            {currency} {value.toFixed(2)}
        </span>;
    }
}